<template>
  <div class="top_box">
    <div class="banner_box " :class="routeMenu == '/search' ? 'search_box' : ''">
      <div class="swiper_open" :class="{ hidden: isFixed, }">
        <el-carousel indicator-position="outside" autoplay :interval="5000" loop>
          <el-carousel-item v-for="(item, index) in setInfo.spreadUrl" :key="index">
            <img v-if="!isVideoUrl(item)" class="swiper_img" :src="item" alt="" draggable="false">
            <video v-else class="swiper_img" style="object-fit:cover" :src="item" :controls="false" autoplay loop
              @contextmenu.prevent muted></video>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="content_top" :class="{ fixed: isFixed }">
        <img class="top_logo" src="../../assets/images/title_logo.png" alt="" v-if="isFixed">
        <div class="permission" v-else>
          Copyright © 2023 - 2026 Together for Good. All Rights Reserved. <br />
          ICP备案/许可证号：京ICP备2026019623号
        </div>
        <div class="information">
          <span v-for="(item, index) in menuList" :key="index" :class="routeMenu == item.route ? 'active' : ''"
            @click="handleGoRouter(item.route)">{{
              item.name }}</span>
        </div>
      </div>
      <div class="websit_search" v-if="!isFixed">
        <div class="webset_title">
          <el-carousel indicator-position="outside" autoplay :interval="4000" loop>
            <el-carousel-item v-for="(item, index) in logoUrl" :key="index">
              <img :src="item" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="search_dom">
          <div class="input_box">
            <el-input placeholder="请输入内容或标题" v-model="keyWord" @keyup.enter.native="handleSearch"></el-input>
          </div>
          <el-select v-model="columnId" placeholder="请选择" clearable>
            <el-option v-for="(item, index) in tabInfo.tabLeft" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <i slot="suffix" class="el-icon-search" @click="handleSearch"></i>
        </div>
        <!-- <el-input placeholder="请输入内容或标题" v-model="keyWord" @keyup.enter.native="handleSearch">
          <i slot="suffix" class="el-icon-search" @click="handleSearch"></i>
        </el-input> -->
      </div>
    </div>


    <div v-if="isFixed" :class="{ fixed: isFixed, small: isFixed }">
      <div :class="{ swiper_close: isFixed, fixed: isFixed }">
        <el-carousel indicator-position="outside" autoplay :interval="5000" loop>
          <el-carousel-item v-for="(item, index) in setInfo.shrinkUrl" :key="index">
            <img class="swiper_img" :src="item" alt="" draggable="false">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="content_top" :class="{ fixed: isFixed }">
        <img class="top_logo" v-if="logoUrl.length" :src="logoUrl[0]" alt="">
        <div class="information">
          <span v-for="(item, index) in menuList" :key="index" :class="routeMenu == item.route ? 'active' : ''"
            @click="handleGoRouter(item.route)">{{
              item.name }}</span>
        </div>
      </div>
    </div>


    <div class="tab_box" v-if="routeMenu == '/home'">
      <div class="tab_list">
        <div class="left_tab">
          <span class="marginRight" v-for="(item, index) in tabInfo.tabLeft" :key="index"
            :class="tabType == item.value ? 'tabActive' : ''" @click="handleTabClick(item.value)">
            {{ item.label }}
            <span v-if="tabType == item.value"></span>
          </span>
        </div>
        <div class="right_tab">
          <span class="marginLeft" v-for="(item, index) in tabInfo.tabRight" :key="index"
            :class="tabType == item.value ? 'tabActive' : ''" @click="handleTabClick(item.value)">
            {{ item.label }}
            <span v-if="tabType == item.value"></span>
          </span>
          <span class="marginLeft" @click="handleGoLogin">
            登录平台
          </span>
        </div>
      </div>
      <div class="homePage" v-if="tabType == 1">
        <div class="title">{{ setInfo.hotspot || '' }}</div>
        <vue-seamless-scroll :data="tableData" :class-option="options" class="assess_box">
          <div class="footprint">
            <div class="footprint_list" v-for="(item, index) in tableData" :key="index" @click="handlePreview(item)">
              <div v-if="item.detailList.length">
                <div class="footprint_title">{{ item.regionName ? item.regionName.replace(/\//g, '') : '' }}</div>
                <img :src="item.detailList[0].imageUrl" alt="">
                <div class="describe">
                  {{ item.detailList[0].title }}
                </div>
                <div class="time">
                  <span>{{ item.createDate }}</span>
                  <img src="../../assets/images/link_icon.png" v-if="item.detailList[0].url"
                    @click.stop="handleGo(item.detailList[0].url)" alt="">
                </div>
              </div>
            </div>
          </div>

        </vue-seamless-scroll>
      </div>
    </div>


    <!-- 预览 -->
    <ArticlePreview ref="articlePreview" />
  </div>
</template>

<script>
import { tabGetList, webSiteData, advertisement, getHomeArticlePage } from '@/api/apis'
import vueSeamlessScroll from 'vue-seamless-scroll'
import ArticlePreview from '@/components/articlePreview/index'
import { dictData } from '@/api/system'
import { getToken } from '@/utils/auth'
export default {
  components: {
    vueSeamlessScroll, ArticlePreview
  },
  data() {
    return {
      logoUrl: [],
      options: {
        step: 0.5, // 滚动速度
        limitMoveNum: 5, // 开始滚动的数据量
        hoverStop: true, // 悬停暂停
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监听
        singleHeight: 0, // 单条数据高度
        waitTime: 1000 // 单步停止等待时间
      },
      keyWord: '',
      columnId: '',
      isFixed: false,
      scrollHeight: 0,
      menuList: [
        { name: '首页', route: '/home' },
        { name: '关于我们', route: '/about' },
        { name: '联系我们', route: '/relation' },
        { name: '意见与建议', route: '/suggest' },
      ],
      routeMenu: '/home',
      tabInfo: {
        tabLeft: [],
        tabRight: [
          { label: '生态应用', value: 'use', needLogin: true },
          // { label: '登录平台', value: 'login' },
        ]
      },
      tabType: '',


      childInfo: {},
      setInfo: {
        // 'https://app.hqhis.com/cdn/images/hospital_bg.png'
        spreadUrl: [],//展开
        shrinkUrl: [],//收缩
        hotspot: ''
      },
      tableData: [],
      loginList: []
    }
  },
  watch: {
    $route(to, from) {
      this.routeMenu = to.path
      this.isFixed = to.path == '/search' ? true : false
      // if (from.path == '/search' && !getToken()) {
      // this.tabType = 5
      // this.handleTabClick(this.tabType)
      // }
    }
  },
  mounted() {
    // 监听窗口滚动
    window.addEventListener('scroll', this.handleScroll);

    this.handleSystemSet()
    this.handleWebSiteData()
    this.handleAdvertisement()
    this.handlearticleData()
    this.handleDictData()
  },
  methods: {
    handleDictData() {
      dictData('u_login_url').then(res => {
        this.loginList = res.rows
      })
    },
    isVideoUrl(url) {
      if (!url) return false

      // 包含这些关键词也视为视频
      const videoKeywords = ['.mp4', '.mov', '.avi', '.mkv', '.flv', '.m3u8', '.webm', 'video/']

      return videoKeywords.some(key => url.toLowerCase().includes(key))
    },
    // 滚动高度处理
    handleScroll() {
      if (this.routeMenu == '/search') return
      if (window.scrollY > 300) {
        this.isFixed = true
      } else if (window.scrollY < 299) {
        this.isFixed = false
      }
    },
    handleGoRouter(r) {
      this.routeMenu = r
      if (this.$route.path == r) return
      this.$router.push(this.routeMenu)
    },
    // tab点击
    handleTabClick(v) {
      if (this.tabType == v) return
      this.tabType = v
      this.handlechildInfo()
    },
    // 跳登录
    handleGoLogin() {
      let _path = this.loginList[0].dictValue
      window.open(_path, '_blank')
    },


    handlechildInfo() {
      Object.assign(this.childInfo, {
        isFixed: this.isFixed,
        tabType: this.tabType,
        routeMenu: this.routeMenu,
        keyWord: this.keyWord,
        columnId: this.columnId,
        tabLeft: this.tabInfo.tabLeft,
        needLogin: this.tabType == 'use' ? true : this.tabInfo.tabLeft.find(item => item.router == this.tabType).needLogin
      })
      this.$emit('child', this.childInfo)
    },
    handleSearch() {
      if (!this.keyWord && !this.columnId) return
      if (this.columnId && this.columnId == 5) {
        if (!getToken()) {
          this.tabType = 5
          this.$message.warning('请先进行登录')
          this.handlechildInfo()
          return
        }
      }
      this.handlechildInfo()
      this.$router.push('/search')
      this.keyWord = ''
      this.columnId = ''
      this.tabType = 1
    },
    // 首页tab
    handleSystemSet() {
      tabGetList().then(res => {
        if (res.data && res.data.length > 0) {
          let _left = []
          res.data.forEach(item => {
            _left.push(item)
          })
          this.tabInfo.tabLeft = _left.map(item => ({
            label: item.name,
            value: item.id,
            ...item
          }))
          setTimeout(() => {
            if (this.$route.query.tabType) {
              this.tabType = this.$route.query.tabType
            } else {
              this.tabType = this.tabInfo.tabLeft[0].value
            }
            this.handlechildInfo()
          }, 300)


        }
      })
    },
    // 网站名称和logo
    handleWebSiteData() {
      webSiteData().then(res => {
        document.title = res.data.title || '益起行动'
        this.logoUrl = res.data.logoUrls ? res.data.logoUrls.split(',') : []
      })
    },
    // 点击预览
    handlePreview(item) {
      this.$refs.articlePreview.show = true
      this.$refs.articlePreview.detailId = item.id
    },
    // 头部展开、收缩、热点
    handleAdvertisement() {
      advertisement().then(res => {
        if (res.data.length) {
          res.data.forEach(item => {
            if (item.advertisement.position == 1) {
              if (item.advertisementDetails.length > 0) {
                this.setInfo.spreadUrl = []
                item.advertisementDetails.forEach(v => {
                  this.setInfo.spreadUrl.push(v.imageUrl)
                })
              }
            } else if (item.advertisement.position == 2) {
              if (item.advertisementDetails.length > 0) {
                this.setInfo.shrinkUrl = []
                item.advertisementDetails.forEach(v => {
                  this.setInfo.shrinkUrl.push(v.imageUrl)
                })
              }
            } else if (item.advertisement.position == 3) {
              this.setInfo.hotspot = item.advertisement.note
            }
          })
        }
      })
    },
    // 查询热点文章
    handlearticleData() {
      let _data = {
        label: 3,
        pageNum: 1,
        pageSize: 10
      }
      getHomeArticlePage(_data).then(res => {
        this.tableData = res.rows
      })
    },
    handleGo(link) {
      if (!link) return
      window.open(link, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {

  .el-carousel__arrow--left,
  .el-carousel__arrow--right {
    display: none !important;
  }
}

.top_box {
  width: 100%;

  .swiper_open {
    transition: all 1s linear;
    opacity: 1;
    visibility: visible;

    ::v-deep {
      .el-carousel {
        height: 522px !important;
        transition: height 1s linear;
      }

      .el-carousel__container {
        height: 93% !important;
        transition: height 1s linear;
      }
    }

    .swiper_img {
      height: 522px;
      width: 100%;
    }
  }

  .swiper_close {
    width: 100%;

    ::v-deep {
      .el-carousel {
        height: 130px !important;
        transition: height 1s linear;
      }

      .el-carousel__container {
        height: 75% !important;
        transition: height 1s linear;
      }
    }

    .swiper_img {
      height: 91px;
      width: 100%;
    }
  }

  .hidden {
    opacity: 0;
    visibility: hidden;
    transform: translateY(-50%);
  }

  .banner_box {
    width: 100%;
    height: 522px;
    transition: height 0.8s linear;
    position: relative;
  }

  .search_box {
    height: 91px !important;
  }

  .fixed {
    position: fixed !important;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
  }

  .small {
    width: 100%;
    height: 93px;
    transition: height 0.8s linear;
    position: relative;
  }

  .content_top {
    width: 1096px;
    height: 71px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;

    .top_logo {
      width: 230px;
      // height: 50px;
      color: #fff;
      font-weight: bold;
    }

    .permission {
      color: #fff;
    }

    .information {
      display: flex;

      span {
        color: #fff;
        cursor: pointer;

        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3) {
          margin-right: 20px;
        }
      }

      .active {
        color: #FF2D55;
      }
    }
  }

  .websit_search {
    width: 1096px;
    position: absolute;
    left: 50%;
    top: 130px;
    transform: translateX(-50%);
    z-index: 999;

    .webset_title {
      width: 384px;
      margin: 0 auto 40px;

      ::v-deep {
        .el-carousel {
          height: 100px !important;
        }

        .el-carousel__container {
          height: 94% !important;
        }
      }

      img {
        width: 100%;
        // height: 50px;
      }

      ::v-deep .el-carousel__indicators--outside {
        display: none;
      }
    }

    .search_dom {
      width: 100%;
      display: flex;
      align-items: center;
      background: #fff;

      .input_box {
        flex: 1;

        ::v-deep .el-input {
          font-size: 18px;
        }

        ::v-deep .el-input__inner {
          height: 79px;
          line-height: 79px;
          border: none;
        }

        ::v-deep .el-input__suffix {
          font-size: 30px;
          line-height: 79px;
          margin-right: 30px;
          cursor: pointer;
        }


      }

      ::v-deep .el-icon-search:before {
        color: #FF2D55 !important;
        margin: 0 20px;
        cursor: pointer;
        font-size: 26px;
      }
    }


  }

  .marginLeft {
    margin-left: 30px;
  }

  .marginRight {
    margin-right: 30px;
  }

  .tab_box {
    width: 100%;

    .tab_list {
      width: 1096px;
      margin: 0 auto;
      border-bottom: 1px solid #E6CFB9;
      height: 136px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left_tab,
      .right_tab {
        display: flex;
        align-items: center;

        >span {
          cursor: pointer;
          color: #000;
          font-size: 18px;
          font-weight: bold;
          position: relative;

          span {
            display: inline-block;
            width: 16px;
            height: 3px;
            background: #FF2D55;
            border-radius: 10px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -5px;
          }
        }

        .tabActive {
          color: #FF2D55;
        }
      }
    }

    .homePage {
      width: 1096px;
      margin: 0 auto;

      .title {
        font-weight: 600;
        font-size: 30px;
        color: #FF2D55;
        margin: 30px 0 20px;
      }

      .assess_box {
        width: 1096px;
        overflow: hidden;
        background: linear-gradient(304deg, #FFFFFF 0%, #FEEEDD 100%);
      }

      .footprint {
        width: 100%;
        padding: 20px;
        border-radius: 10px;
        display: flex;

        .footprint_list {
          width: 255px;
          margin-right: 20px;

          .footprint_title {
            color: #000000;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 10px;
          }

          img {
            width: 255px;
            border-radius: 10px;
          }

          .describe {
            width: 100%;
            color: #000000;
            font-size: 18px;
            font-weight: 600;
            margin: 5px 0;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            /* 控制显示几行 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-break: break-all;
            /* 防止英文不换行 */
          }

          .time {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
              color: #8E8E8E;
              font-size: 16px;
            }

            img {
              width: 22px;
              height: 22px;
              cursor: pointer;
            }
          }
        }
      }
    }

  }
}
</style>